var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatCowboySide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M638.2 360.8c-19.25-89.62-78.13-152.5-150.8-165.5l-19.12-109.1c-5.25-30.75-31.88-53.25-63-53.25c-9.375 0 3.256-2.121-204.5 42C173.7 79.77 153.5 102.3 150.5 129.8L143.2 196.9c-68.25 16.62-123.1 77.1-141.5 163.9c-4.375 20.75-.375 42.5 10.88 59.5C24.49 437.9 42.36 448 61.86 448h516.3c19.5 0 37.38-10.12 49.25-27.75C638.7 403.3 642.6 381.5 638.2 360.8zM182.2 133.1c1.5-13.75 11.63-24.1 25.25-27.87L398.6 64.77c19.38-4.125 35.38 9.375 38.25 25.1l28.75 165.2H316.2L286.7 230.6c-49-39.25-95.25-38.62-110.8-38.12L182.2 133.1zM61.86 416c-20.63 0-33.63-25.75-28.88-48.5c18.5-85.87 77.63-143.5 147.4-143.5c30.75 0 60.63 10.87 85.5 30.87c179.8 154.7 163.5 144.7 187.9 161.1H61.86zM385.2 315.4l-31.88-27.37h117.8l19.63 112.2C457.7 384.5 432.1 356.5 385.2 315.4zM578.1 416c-5.375 0-29.5 .375-53-4.375l-31.75-182.2c54.5 15.25 98.13 66.62 113.5 137.1C612.6 393.8 595.9 416 578.1 416z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatCowboySide);
export default __webpack_public_path__ + "static/media/hat-cowboy-side.4e7eaf9836652fcbb44e9dbcc12a695a.svg";
export { ForwardRef as ReactComponent };